var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","opacity":"0.8"}},[_c('div',{attrs:{"id":"amazonPayButton","loading":_vm.loading}})])
}
var staticRenderFns = []

export { render, staticRenderFns }